var map = {
	"./Accordion.svg": "5657",
	"./Bagpipe.svg": "434d",
	"./Bass.svg": "9c20",
	"./Bongo.svg": "ed39",
	"./Cabasa.svg": "0481",
	"./Castanets.svg": "8821",
	"./Clap.svg": "7145",
	"./Conga.svg": "f262",
	"./Cowbells.svg": "28df",
	"./Flute.svg": "572a",
	"./Guitar.svg": "0c9e",
	"./Hand Clap.svg": "c4b5",
	"./Kalimba.svg": "88ab",
	"./Maracas.svg": "3691",
	"./Marimba.svg": "f5db",
	"./Pan.svg": "0027",
	"./Piano.svg": "58cd",
	"./Piffero.svg": "837e",
	"./Snare.svg": "5d6e",
	"./Tambourine.svg": "6630",
	"./Triangle.svg": "bedd",
	"./Vibraphone.svg": "0ac9",
	"./Woodblock.svg": "2253"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ffdf";